const OPEN_STATUSES = ['not_sent', 'sent', 'viewed'];

function lineMatchesAllocation(line, allocationId) {
  const lineAllocationId = line?.allocation_id || line?.allocationId;
  if (!lineAllocationId || !allocationId) return false;
  return String(lineAllocationId) === String(allocationId);
}

function quoteHasAllocationLine(quote, allocationId) {
  const lines = quote?.breakdown?.line_items || [];
  return lines.some(line => lineMatchesAllocation(line, allocationId));
}

/**
 * Open quotes (not_sent | sent | viewed) that include a line item for the given allocation.
 */
export function openQuotesForAllocation(quotes, allocationId) {
  if (!allocationId) return [];
  return (quotes || []).filter(
    quote =>
      OPEN_STATUSES.includes(quote?.status) &&
      quoteHasAllocationLine(quote, allocationId)
  );
}

export function quoteDisplayLabel(quote, t) {
  if (!quote) return '';
  const name =
    quote.name ||
    (typeof t === 'function' ? t('PLANNING.SHOW.QUOTE_DETAIL_TITLE') : 'Quote');
  if (quote.version == null) return name;
  const version =
    typeof t === 'function'
      ? t('PLANNING.SHOW.QUOTE_VERSION_SHORT', { version: quote.version })
      : `v${quote.version}`;
  return `${name} (${version})`;
}
